import { Form } from '@/shared/form/form';
import { Timer } from '@/shared/common/timer/timer';
import { classInstance } from '@/shared/helpers/helpers';

export class ModalAuth {
	isCodeComplete = false;
	isTelComplete = false;

	constructor(selector) {
		this.$container = selector;
		if (!this.$container) return;
		this.init();
	}

	init() {
		this.authByPhoneForm = this.$container.querySelector('.js-auth-by-phone-form');
		this.authByEmailForm = this.$container.querySelector('.js-singin-email-form');

		this.codeForm = this.$container.querySelector('.js-code-form');
		this.changePhoneBtn = this.$container.querySelector('.js-modal-auth-change-phone');
		this.resendCodeBtn = this.$container.querySelector('.js-modal-auth-resend-code');
		this.numberSent = this.$container.querySelector('.modal-auth__instruction span');
		
		this.codeInput = this.codeForm?.querySelector('input');
		this.codeInputInstance = classInstance.get(this.codeInput).formElement;
		this.codeError = this.codeForm?.querySelector('.modal-auth__error-msg');

		this.telInput = this.$container?.querySelector('.modal-auth__tel .form-input');
		this.telInputInstance = classInstance.get(this.telInput)?.formElement;

		this.emailInput = this.authByEmailForm?.querySelector('.form-input[type="email"]');
		this.emailInputInstance = classInstance.get(this.emailInput)?.formElement;

		this.count = this.$container.dataset.count || 60;

		if (this.authByPhoneForm) {
			this.authByPhoneFormInstance = new Form(this.authByPhoneForm);
		}

		if (this.authByEmailForm) {
			this.authByEmailFormInstance = new Form(this.authByEmailForm);
		}

		this.resetStartAnimation();

		this.timer = new Timer(this.resendCodeBtn, {
			count: Number(this.count),
			type: 'number',
			format: (data) =>
				`Отправить код повторно через ${data.seconds.value} ${data.seconds.name}`,
		});

		this.resendCodeBtn?.addEventListener('timerComplete', this.timerCompleteHandler);
		this.changePhoneBtn?.addEventListener('click', this.changePhoneHandler);
		this.codeInput.addEventListener('input', this.handleCodeInput);
		this.telInput?.addEventListener('input', this.handleTelInput);
		this.authByPhoneForm?.addEventListener('submit', this.submitByPhoneHandler);
		this.authByEmailForm?.addEventListener('submit', this.submitByEmailHandler);
		this.resendCodeBtn?.addEventListener('click', this.resendCodeHandler);
	}

	resetStartAnimation() {
		setTimeout(() => {
			this.$container.classList.remove('hidden');
		}, 2000);
	}

	showCodeForm = () => {
		this.authByPhoneForm.classList.add('hidden');
		this.codeForm.classList.remove('hidden');
	};

	hideCodeForm = () => {
		this.authByPhoneForm.classList.remove('hidden');
		this.codeForm.classList.add('hidden');
	};

	startTimer = () => {
		this.timer.start();
		this.resendCodeBtn.setAttribute('disabled', true);
	};

	resetTimer = () => {
		this.timer.reset();
		this.resendCodeBtn.removeAttribute('disabled');
		this.resendCodeBtn.textContent = 'Отправить код повторно';
	};

	timerCompleteHandler = () => {
		this.timer.reset();
		this.resendCodeBtn.removeAttribute('disabled');
		this.resendCodeBtn.textContent = 'Отправить код повторно';
	};

	changePhoneHandler = () => {
		this.hideCodeForm();
		this.resetTimer();
	};

	handleCodeInput = ({ target }) => {
		if (this.isCodeComplete && this.codeInputInstance.validate({ noRender: true })) return;
		 else if (this.codeInputInstance.validate({ noRender: true }) && !this.isCodeComplete) {
			this.$container.dispatchEvent(new CustomEvent('codeComplete', { detail: { code: target.value.replaceAll(' ', '').replaceAll('_', '') } }));
			this.isCodeComplete = true;
		} else this.isCodeComplete = false;
	};

	handleTelInput = ({ target }) => {
		if (this.isTelComplete && this.telInputInstance.validate({ noRender: true })) return;
		else if (this.telInputInstance.validate({ noRender: true }) && !this.isTelComplete) {
			this.$container.dispatchEvent(new CustomEvent('telComplete', { detail: { tel: target.value } }));
			this.isTelComplete = true;
		} else this.isTelComplete = false;
	};

	showTelInputError = (message) => this.telInputInstance.renderError(message);
	
	showEmailInputError = (message) => this.emailInputInstance.renderError(message);

	showCodeInputError = (message) => this.codeInputInstance.renderError(message);

	showCodeFormError = (message) => {
		if (message) this.codeError.innerText = message;
		this.codeError.classList.remove('hidden');
	};

	hideCodeFormError = () => this.codeError.classList.add('hidden');

	setNumber = (number) => {
		this.numberSent.innerText = number;
	};

	resendCodeHandler = () => {
		this.startTimer();

		this.$container.dispatchEvent(
			new CustomEvent('resendCode', {
				detail: {
					data: new FormData(this.authByPhoneForm),
				},
			}),
		);
	};

	submitByPhoneHandler = (event) => {
		event.preventDefault();

		if (!this.authByPhoneFormInstance.formCheck(false)) {
			return;
		}
		
		this.$container.dispatchEvent(
			new CustomEvent('submitPhone', {
				detail: {
					data: new FormData(this.authByPhoneForm),
				},
			}),
		);
	};

	submitByEmailHandler = (event) => {
		event.preventDefault();

		if (!this.authByEmailFormInstance.formCheck(false)) {
			return;
		}

		this.$container.dispatchEvent(
			new CustomEvent('submitEmail', {
				detail: {
					data: new FormData(this.authByEmailForm),
				},
			}),
		);
	};
}
